import { redirect } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"

import { getUserType } from "@/lib/supabase/auth"
import { createClient } from "@/lib/supabase/server"
import { normalizePhoneNumberForSupabase } from "@/lib/utils"

export const logout = createServerFn({ method: "POST" }).handler(async () => {
  const supabase = createClient()
  await supabase.auth.signOut()
  throw redirect({ to: "/login" })
})

export const sendOtp = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) =>
    z.object({ phone: z.string().min(1) }).parse(data)
  )
  .handler(async ({ data }) => {
    const supabase = createClient()
    const normalizedPhone = normalizePhoneNumberForSupabase(data.phone)
    const { error } = await supabase.auth.signInWithOtp({
      phone: `+${normalizedPhone}`,
      options: { shouldCreateUser: false },
    })
    if (error) {
      console.error("sendOtp error:", {
        message: error.message,
        phoneLast4: normalizedPhone.slice(-4),
      })
      return { hasError: true, message: error.message }
    }
    return { hasError: false }
  })

export const verifyOtp = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) =>
    z.object({ phone: z.string().min(1), token: z.string().min(1) }).parse(data)
  )
  .handler(async ({ data }) => {
    const supabase = createClient()
    const { error } = await supabase.auth.verifyOtp({
      phone: `+${normalizePhoneNumberForSupabase(data.phone)}`,
      token: data.token,
      type: "sms",
    })
    if (error) {
      return { hasError: true, message: error.message }
    }
    // Session cookies are set automatically by supabase server client's setAll callback
    const {
      data: { user },
    } = await supabase.auth.getUser()
    if (!user) return { hasError: false, redirectTo: "/" }
    const userType = await getUserType(user)
    let redirectTo = "/"
    if (userType === "admin") redirectTo = "/admin"
    if (userType === "terminal") redirectTo = "/terminal"
    return { hasError: false, redirectTo }
  })
